export default "__VITE_ASSET__DE0daeAS__"